<template>
  <div class="recipient-camera-list">
    <div class="recipient-camera-list--header">
      <span>{{`Select Camera Device (${identity})`}}</span>
      <span @click="$emit('close')">&times;</span>
    </div>
    <div class="recipient-camera-list--body">
      <div
        v-for="camera in cameraList"
        :key="camera.deviceId"
        class="recipient-camera-list--item"
        @click="selectDevice(camera.deviceId)"
      >
        {{ camera.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipientCameraList",
  props: {
    identity: String,
    cameraList: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {};
  },
  methods: {
    selectDevice(deviceId) {
      this.$emit("selected", { deviceId, identity: this.identity });
    }
  }
};
</script>

<style lang="scss" scoped>
.recipient-camera-list {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;

  &--header {
    width: 100%;
    height: 30px;
    background-color: black;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    padding: 0 8px 0 16px;

    > span {
      font-size: 14px;
      font-weight: bold;

      &:last-child {
        cursor: pointer;
        font-size: 20px;
      }
    }
  }

  &--body {
    width: 100%;
    height: calc(100% - 42px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  &--item {
    width: 100%;
    height: 30px;
    padding: 0 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
    font-weight: normal;
    line-height: 30px;
    color: white;
    background-color: black;
    cursor: pointer;

    &:hover {
      background-color: #202124;
    }
  }
}
</style>
